const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_yY5JAcwxX",
    "aws_user_pools_web_client_id": "459jcv0nn4uvcbv9cnndnk572o",
    "oauth": {},
    "aws_cognito_username_attributes": ["EMAIL"],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": ["EMAIL", "NAME"],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8
    },
    "aws_cognito_verification_mechanisms": ["EMAIL"]
};

export default awsmobile;